import React from "react";

import { IFieldType, IFormSchema, IFormWidgetType } from "shared/types";
import { WeightUnits, DistanceUnits } from "shared/utils";
import { Dimensions, Weight as WeightIcon } from "shared/assets/icons";
import { copy } from "shared/assets";

const { stageProperties } = copy;

export const dimensionsFormData: IFormSchema = {
  fields: [
    {
      title: stageProperties.dimensions.title,
      name: "dimensions",
      hideContainer: true,
      fields: [
        {
          name: "unitConverter",
          widget: IFormWidgetType.unitConverter,
        },
        {
          name: "room",
          label: (
            <React.Fragment>
              <Dimensions key="room_dimensions_icon" />
              <span key="room_dimensions_label">
                {stageProperties.dimensions.properties.roomDimensions}
              </span>
            </React.Fragment>
          ),
          hideContainer: true,
          separator: "✕",
          fields: [
            {
              type: IFieldType.dimension,
              name: "width",
              label: "Width",
              hideLabel: true,
              placeholder: "width",
              min: 0,
              unit: {
                metric: DistanceUnits.m,
                imperial: DistanceUnits.ft,
              },
            },
            {
              type: IFieldType.dimension,
              name: "height",
              label: "Height",
              hideLabel: true,
              placeholder: "height",
              min: 0,
              unit: {
                metric: DistanceUnits.m,
                imperial: DistanceUnits.ft,
              },
            },
            {
              type: IFieldType.dimension,
              name: "depth",
              label: "Depth",
              hideLabel: true,
              placeholder: "depth",
              min: 0,
              unit: {
                metric: DistanceUnits.m,
                imperial: DistanceUnits.ft,
              },
            },
          ],
        },
        {
          name: "stage",
          label: (
            <React.Fragment>
              <Dimensions key="stage_dimensions_icon" />
              <span key="stage_dimensions_label">
                {stageProperties.dimensions.properties.stageDimensions}
              </span>
            </React.Fragment>
          ),
          hideContainer: true,
          separator: "✕",
          fields: [
            {
              type: IFieldType.dimension,
              name: "width",
              label: "Width",
              hideLabel: true,
              placeholder: "width",
              min: 0,
              unit: {
                metric: DistanceUnits.m,
                imperial: DistanceUnits.ft,
              },
            },
            {
              type: IFieldType.dimension,
              name: "height",
              label: "Height",
              hideLabel: true,
              placeholder: "height",
              min: 0,
              unit: {
                metric: DistanceUnits.m,
                imperial: DistanceUnits.ft,
              },
            },
            {
              type: IFieldType.dimension,
              name: "depth",
              label: "Depth",
              hideLabel: true,
              placeholder: "depth",
              min: 0,
              unit: {
                metric: DistanceUnits.m,
                imperial: DistanceUnits.ft,
              },
            },
          ],
        },
      ],
    },
    {
      type: IFieldType.dimension,
      name: "distanceFromLoadingToStage",
      label: (
        <React.Fragment>
          <Dimensions key="distanceFromLoadingToStage_icon" />
          <span key="distanceFromLoadingToStage_label">
            {stageProperties.dimensions.properties.distanceFromLoadingToStage}
          </span>
        </React.Fragment>
      ),
      min: 0,
      unit: {
        metric: DistanceUnits.m,
        imperial: DistanceUnits.ft,
      },
    },
    {
      type: IFieldType.dimension,
      name: "stageWeightPerSquareMeter",
      label: (
        <React.Fragment>
          <WeightIcon key="stageWeightPerSquareMeter_icon" />
          <span key="stageWeightPerSquareMeter_label">
            {
              stageProperties.dimensions.properties.stageWeightPerSquareMeter
                .full
            }
          </span>
        </React.Fragment>
      ),
      min: 0,
      unit: {
        metric: WeightUnits.kg,
        imperial: WeightUnits.lbs,
      },
    },
  ],
};
